<template lang="pug">
  nav.profile-tabs
    ul.profile-tabs__items
      li.profile-tabs__item(
        v-for="(item, index) in items"
        v-if="item"
        :key="item.id || index"
        :class="{ '--active': activeTabIndex === index, '--disabled': item.isDisabled }"
        @click.prevent="onItemClick(index, item)"
      )
        a.profile-tabs__link
          img(v-if="item.icon" :src="item.icon" :alt="item.title")
          span.profile-tabs__link-title {{ item.title }}
        span.profile-tabs__dot(v-if="showPoint(item)")

</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'ProfileTabs',

  props: {
    items: {
      type: Array,
      required: true
    },

    activeTabIndex: {
      type: Number,
      default: -1
    }
  },

  computed: {
    ...mapState('chat', ['newMessages'])
  },

  watch: {
    activeTabIndex: {
      handler (index) {
        if (process.server || index < 0) {
          return
        }

        setTimeout(() => {
          this.$el
            .querySelectorAll('li')
            [index].scrollIntoView({ inline: 'center', block: 'nearest' })
        }, 250)
      },

      immediate: true
    }
  },

  methods: {
    ...mapMutations('user', ['setOfferwallPathState']),

    onItemClick (index, item) {
      if (item.id === 'offerwall-tickets') {
        this.$cookiz.set('offerwall-tickets-dot-hide', true)
      } else if (item.id === 'offerwall-euro') {
        this.$cookiz.set('offerwall-euro-dot-hide', true)
      }

      const { isDisabled } = this.items[index]

      if (isDisabled) {
        return
      }

      this.$emit('change', { index, item: this.items[index] })
    },

    checkOfferwallPath () {
      this.setOfferwallPathState(
        !(
          this.$cookiz.get('offerwall-tickets-dot-hide') &&
          this.$cookiz.get('offerwall-euro-dot-hide')
        )
      )
    },

    showPoint (item) {
      switch (item.id) {
        case 'orders':
          return this.newMessages?.length
        default:
          return false
      }
    }
  }
}
</script>

<style lang="scss">
.profile-tabs {
  height: 48px;
  max-width: 100%;
  user-select: none;

  &__items {
    @include scroll-none;

    max-width: 100%;
    display: flex;
    height: 100%;
    line-height: 48px;
    align-items: center;
    border-bottom: 1px solid $blue-grey50;
    overflow-x: auto;
    overflow-y: hidden;

    a {
      font-size: 17px;
      font-weight: $font-medium;
      white-space: nowrap;
      color: $blue-grey10;
      transition: opacity 0.2s $easing;
      display: flex;
      align-items: center;
      height: 100%;

      img {
        max-width: 24px;
        height: 24px;
        margin-right: 6px;
      }

      svg {
        max-width: 24px;
        height: 24px;
        margin-right: 6px;
      }
    }
  }

  &__item {
    padding: 0 16px;
    margin-right: 8px;
    position: relative;
    height: 100%;
    cursor: pointer;

    &:hover {
      a {
        color: white;
      }
    }

    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      height: 2px;
      background: $amber60;
      width: 100%;
      transform: scaleX(0);
      transition: transform 0.1s $easing;
    }

    &.--active {
      background: $blue-grey60;
      border-radius: 8px 8px 0 0;

      &::after {
        transform: scaleX(1);
        transition: transform 0.2s $easing;
      }

      a {
        color: $white;
      }
    }

    &.--disabled {
      cursor: not-allowed;
      opacity: 0.5;

      a {
        color: $white;
      }

      svg path {
        fill: $white;
      }
    }

    &:last-child {
      margin-right: 0;
    }
  }

  &__dot {
    position: absolute;
    top: 19px;
    left: 0;
    height: 8px;
    width: 8px;
    background-color: $pink60;
    border-radius: 50%;
    display: inline-block;
  }
}
</style>
